import apiUrl from '../../../../../utils/settings';

export const TreePlantationUrl = () => {
  return apiUrl + '/benefits-v2/plantation-details';
};

export const TreePlantationCertificateUrl = () => {
  return apiUrl + '/benefits-v2/plantation/certificate';
};

export const PlantationUrl = () => {
  return apiUrl + '/benefits-v2/plantation';
};

export const TreeBannersUrl = () => {
  return apiUrl + '/home/tree-banners';
};
